import React from 'react';

import EdiUpload from 'components/LM/SocialMediaProfile/MassImport/Upload';
import OverallStatus from 'components/LM/SocialMediaProfile/MassImport/status/OverallStatus';
import BssoPermissions from "components/LM/Bsso/Permissions";
import {Switch, Route} from "react-router-dom";

function MassImportView() {
	return (
		<BssoPermissions permissions={['voices']} behaviour="error">
			<Switch>
				<Route path="/orphan/import" exact>
					<EdiUpload />
				</Route>
				<Route path="/orphan/import/status" exact>
					<OverallStatus />
				</Route>
			</Switch>
		</BssoPermissions>
	);
}

export default MassImportView;
